import { apiService } from './apiService';
import { API_CONFIG } from '@/config/apiConfig';
import { DeliveryAddress } from '@/types';

export interface PreparoStatusPayload {
  estacao?: string; // cozinha, bar, etc
  itens?: Array<{ pedidoItemId?: number; produtoId?: number; quantidade?: number; status: string; observacao?: string; startedAt?: string; finishedAt?: string }>;
  status?: string; // geral
  prioridade?: number;
}

export interface EntregaStatusPayload {
  status: string; // Pendente, EmSeparacao, EmRota, Entregue, etc
  motorista?: string;
  janela?: string;
  tipoPedido?: 'delivery' | 'pickup' | 'takeout' | 'dine-in';
  endereco?: DeliveryAddress;
  taxaEntrega?: number;
  observacao?: string;
  eventos?: Array<{ data: string; tipo: string; comentario?: string }>;
}

export const orderStatusService = {
  async getPreparoStatus(vendaID: number) {
    const endpoint = API_CONFIG.endpoints.orders.getPreparoStatus;
    return apiService.get(endpoint, { vendaID });
  },
  async setPreparoStatus(vendaID: number, payload: PreparoStatusPayload) {
    const endpoint = API_CONFIG.endpoints.orders.setPreparoStatus;
    return apiService.post(endpoint, payload, { vendaID });
  },
  async getEntregaStatus(vendaID: number) {
    const endpoint = API_CONFIG.endpoints.orders.getEntregaStatus;
    return apiService.get(endpoint, { vendaID });
  },
  async setEntregaStatus(vendaID: number, payload: EntregaStatusPayload) {
    const endpoint = API_CONFIG.endpoints.orders.setEntregaStatus;
    return apiService.post(endpoint, payload, { vendaID });
  },
};
